import LayoutContainer from 'components/Container';
import { addMonths } from 'date-fns';
import withExcludeForBots from 'hocs/with-exclude-for-bots';
import { useCookie } from 'hooks/use-cookie';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import { Cookies } from 'services/cookie';
import { useCookiesAllowed } from 'store/Misc/use-cookies-allowed';

import { Container, Content } from './styles';

const BetaBanner = () => {
  const { t } = useTranslation();
  const [isHidden, setIsHidden] = useCookie(Cookies.BETA_BANNER_HIDDEN, false);
  const [cookiesAllowed] = useCookiesAllowed();

  if (!cookiesAllowed) {
    return null;
  }

  if (isHidden) {
    return null;
  }

  const onCloseClick = () =>
    setIsHidden(true, {
      path: '/',
      expires: addMonths(new Date(), 1),
    });

  return (
    <Container>
      <LayoutContainer>
        <Content>
          <FaExclamationTriangle size="1.15em" />
          <p>
            <b>{t('feedback.beta.title')}</b> {t('feedback.beta.text')}
          </p>
          <a onClick={onCloseClick}>
            <FaTimes />
          </a>
        </Content>
      </LayoutContainer>
    </Container>
  );
};

export default withExcludeForBots(BetaBanner);
